import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39fc3d8d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=39fc3d8d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc3d8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fc3d8d')) {
      api.createRecord('39fc3d8d', component.options)
    } else {
      api.reload('39fc3d8d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39fc3d8d&scoped=true", function () {
      api.rerender('39fc3d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/devise/index.vue"
export default component.exports